var awsSignWeb = require( 'aws-sign-web' );

registerGlobal( 'EmscriptenHbi' );
EmscriptenHbi = {

    STATE : {
        PENDING_CREDENTIALS_RESOLVE : 1,
        PENDING_UPLOAD : 2,
        WAITING : 3
    },

    TARGET : {
        FIREHOSE : 1,
        WEBPROXY : 2
    },

    TICK_FREQ : 100,
    FAILURE_RETRY_DELAY : 30000,

    init: function( credentialsBrokerUrl, uploadEventsUrl, webproxyUrl, dashboardUrl, logEnabled ) {
        this.logEnabled = logEnabled > 0;
        this.log( "init " + credentialsBrokerUrl + " " + uploadEventsUrl  + " " + logEnabled );

        this.credentials = null;
        this.awsSigner = null;

        this.tickState = this.STATE.WAITING;
        this.credentialsBrokerUrl = credentialsBrokerUrl;
        this.uploadEventsUrl = uploadEventsUrl;
        this.webproxyUrl = webproxyUrl.replace( 'http://', 'https://' ); // force https on facebook
        this.dashboardUrl = dashboardUrl;
        this.toUpload = [];
        this.delayTimeStamp = 0;
        this.errors = 0;
        this._gpuVendor = null;
        this._gpuRenderer = null;
        this._gpuExtensions = null;
        this._allowSendSensitiveData = false;

        this.chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        this.lookup = new Uint8Array(256);
        for (var i = 0; i < this.chars.length; i++) {
            this.lookup[this.chars.charCodeAt(i)] = i;
        }

        this.target = this.TARGET.WEBPROXY;
        this.tryToGetGpuInfo();

        setTimeout( this.processTick.bind( this ), this.TICK_FREQ );
    },

    upload: function( blob ) {
        this.log( "uploadData " + blob.length );
        this.toUpload.push( blob );
    },

    uploadDashboard: function( payload ) {
        var req = new XMLHttpRequest();

        req.open( 'POST', this.dashboardUrl, true );
        req.setRequestHeader( 'Content-Type', 'application/json' );
        req.send( payload );
    },

    storageGet: function( key ) {
        try {
            if( typeof( Storage ) && window.localStorage !== undefined ) {
                var val = window.localStorage.getItem( key );
                return this.toCString( val );
            }
        } catch( err ) {
            return 0;
        }
    },

    storagePut: function( key, value ) {
        try {
            if( typeof( Storage ) && window.localStorage !== undefined ) {
                window.localStorage.setItem( key, value  );
            }
        } catch( err ) {
        }
    },

    storageReset : function ( key ) {
        try {
            if( typeof( Storage ) && window.localStorage !== undefined ) {
                window.localStorage.removeItem( key );
                this.log( "Key " + key + " removed successfully from local storage." );
            }
        } catch( err ) {
            this.log( "Removing " + key + " from localStorage failed due to: " + err.name + ", " + err.message );
        }
    },

    gpuVendor: function() {
        return this.toCString( this._gpuVendor );
    },
    
    gpuRenderer: function() {
        return this.toCString( this._gpuRenderer );
    },

    gpuExtensions: function() {
        return this.toCString( this._gpuExtensions );
    },

    processTick: function() {
        var doWork = true;

        if( this.errors > 2 && this.delayTimeStamp > 0 ) {
            if( this.time() - this.delayTimeStamp < this.FAILURE_RETRY_DELAY ) {
                doWork = false;
            }
        }

        if( doWork && this.tickState == this.STATE.WAITING ) {
            if( this.credentials == null ) {

                this.getCredentials();
            } else if( this.toUpload.length > 0 ) {
                this.processUploads();
            }
        }
        setTimeout( this.processTick.bind( this ), this.TICK_FREQ );
    },

    getCredentials: function() {
        this.log( 'getCredentials' );

        this.tickState = this.STATE.PENDING_CREDENTIALS_RESOLVE;
        this.credentials = null;
        this.ip = null;
        this.clientTimeRef = null;
        this.serverTimeRef = null;

        var $this = this;
        var req = new XMLHttpRequest();

        this.log( 'tickstate ' + this.tickState );

        req.onreadystatechange = function() {
            if( req.readyState == 4 ) {
                $this.log( 'getCredentials response ' + req.readyState + ' ' + req.status );
 
                if( req.status == 200 ) {
                    $this.log( req.responseText );

                    var resp = JSON.parse( req.responseText );

                    if( resp.ok == true ) {
                        $this.ip = resp.ip.split( '.' ).map( function( octet ) { return parseInt( octet ); } );
                        $this.credentials = { 'pb' : resp[ 'public' ],
                            'sc' : resp[ 'secret' ],
                            'tk' : resp[ 'token' ] };
                        $this.clientTimeRef = $this.time();
                        $this.serverTimeRef = resp[ 'time' ];

                        var config = {
                            region: 'us-east-1',
                            service: 'firehose',
                            accessKeyId: resp[ 'public' ],
                            secretAccessKey: resp[ 'secret' ],
                            sessionToken: resp[ 'token' ],
                            defaultContentType: 'application/x-amz-json-1.1'
                        };

                        $this.awsSigner = new awsSignWeb.AwsSigner( config );
                        $this.resetErrors();
                    }
                } else {
                    $this.bumpErrors();
                }
                $this.tickState = $this.STATE.WAITING;
            }
        };
        req.open( "GET", this.credentialsBrokerUrl, true );
        req.setRequestHeader( 'Content-Type', 'text/plain' );
        req.send();
    },

    processUploads: function() {
        this.log( 'processUploads ' + this.toUpload.length );

        var blob = this.toUpload[ 0 ];
        var req = new XMLHttpRequest();
        var $this = this;

        this.updateHeader( blob );
        this.tickState = this.STATE.PENDING_UPLOAD;

        if( this.target == this.TARGET.FIREHOSE ) {
            this.log( 'processUploads targeting firehose' );

            var body = this.makePutRecordRequest( blob );
            var request = {
                method: 'POST',
                url: this.uploadEventsUrl,
                body: body,
                headers: {},
                params: {}
            };
            var signed = this.awsSigner.sign( request, new Date( this.syncedTime() ) );

            req.open( 'POST', this.uploadEventsUrl, true );
            req.setRequestHeader( 'x-amz-target', 'Firehose_20150804.PutRecord' );

            for( var name in signed ) {
                req.setRequestHeader( name, signed[ name ] );
            }
            req.send( body );
        } else {
            this.log( 'processUploads targeting webproxy' );

            req.open( 'POST', this.webproxyUrl, true );
            req.setRequestHeader("Content-type", "application/octet-stream");
            req.send( blob );
        }

        req.onreadystatechange = function() {
            if( req.readyState == 4 ) {
                $this.log( 'response ' + req.readyState + ' ' + req.status );

                var status = req.status;

                if( status == 200 ) {
                    $this.log( 'Upload ok' );

                    $this.log( req.responseText );
                    $this.toUpload.shift();
                    $this.resetErrors();
                } else {
                    // this will trigger credentials renewal
                    $this.credentials = null;
                    $this.switchTarget();
                    $this.bumpErrors();
                }
                $this.tickState = $this.STATE.WAITING;
            }
        };
    },
    
    updateHeader: function( blob ) {
        // 21 timestamp
        // 29 ip

        var view = new DataView( blob.buffer );

        view.setUint8( 29, this._allowSendSensitiveData ? this.ip[ 0 ] : 0 );
        view.setUint8( 30, this._allowSendSensitiveData ? this.ip[ 1 ] : 0 );
        view.setUint8( 31, this._allowSendSensitiveData ? this.ip[ 2 ] : 0 );
        view.setUint8( 32, this._allowSendSensitiveData ? this.ip[ 3 ] : 0 );
 
        var now = this.syncedTime();    

        now = now.toString(  16 );
        while( now.length < 16 )
            now = '0' + now;
        for( var i = 0; i < 8; i++ ) {
            var b = now.substring( i * 2, i* 2 + 2 ) ;
            view.setUint8( 21 + i, parseInt( b, 16 ) );
        }
    },
    
    makePutRecordRequest: function( blob ) {
        var json = {
           "DeliveryStreamName": "sdk-events",

           "Record": {
                 "Data": this.base64( blob )
            }
        };
        return JSON.stringify( json );
    },

    base64: function( buf ) {
        var bytes = new Uint8Array( buf ),
        i, len = bytes.length, base64 = "";

        for (i = 0; i < len; i+=3) {
            base64 += this.chars[bytes[i] >> 2];
            base64 += this.chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
            base64 += this.chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
            base64 += this.chars[bytes[i + 2] & 63];
        }

        if ((len % 3) === 2) {
            base64 = base64.substring(0, base64.length - 1) + "=";
        } else if (len % 3 === 1) {
            base64 = base64.substring(0, base64.length - 2) + "==";
        }
        return base64;
    },
    
    toCString: function( str ) {
        if( str == null )
            return 0;
        var buffer = Module._malloc( str.length + 1 );
        // newer versions of Emscripten exports global stringToUTF8 function instead of Module.stringToUTF8
        var strFunc = Module.stringToUTF8 || stringToUTF8;
        strFunc( str, buffer, str.length + 1 );

        return buffer;
    },
    
    bumpErrors: function() {
        this.delayTimeStamp = this.time();
        this.errors++;
    },
    
    resetErrors: function() {
        this.delayTimeStamp = 0;
        this.errors = 0;
    },

    tryToGetGpuInfo: function() {
        // works only with claw::emscripten
        var canvas = document.getElementById( 'canvas' );

        if( canvas != null && canvas.className == 'emscripten' ) {
            var gl = canvas.getContext( 'webgl' );

            if( gl != null ) {
                try {
                    // requires debug info ext
                    var debugInfo = gl.getExtension( 'WEBGL_debug_renderer_info' );
                    this._gpuVendor = gl.getParameter( debugInfo.UNMASKED_VENDOR_WEBGL );
                    this._gpuRenderer = gl.getParameter( debugInfo.UNMASKED_RENDERER_WEBGL );
                } catch( ex ) {
                }

                try {
                    var exts = gl.getSupportedExtensions();

                    if( exts != null ) {
                        this._gpuExtensions = exts.join( ' ' );
                    }
                } catch( ex ) {
                }

                this.log( "Get gpu info" );
                this.log( this._gpuVendor );
                this.log( this._gpuRenderer );
                this.log( this._gpuExtensions );
            }
        }
    },
    
    log: function( str ) {
        if( this.logEnabled ) {
            console.log( 'HBI js ' + str );
        }
    },

    syncedTime : function() {
        var localDelta = this.time() - this.clientTimeRef;
        return this.serverTimeRef + localDelta;
    },

    time: function() {
        return ( new Date() ).getTime();
    },

    switchTarget: function() { 
        if( this.target == this.TARGET.FIREHOSE )
            this.target = this.TARGET.WEBPROXY;
        else
            this.target = this.TARGET.FIREHOSE;
    },

    allowSendSensitiveData: function( allow ) {
        this._allowSendSensitiveData = allow;
    }
};



//////////////////
// WEBPACK FOOTER
// /src/contrib/huuugeanalyticssdk/cpp/src/js/Application.hbi.js
// module id = 33
// module chunks = 0